import { MoveDiagonal2Icon, MoveHorizontalIcon, MoveVerticalIcon, ScaleIcon } from 'lucide-react';

import type { MeasurementDTO } from '@invenco/common-interface/shared';
import type { SkuDTO } from '@invenco/products-interface';

import { DialogTrigger } from '@/components/core/dialog';
import { DetailEditButton, DetailList } from '@/components/detail-list';
import { FormDialog } from '@/components/forms/form-dialog';
import { formatMeasurement } from '@/shared/helpers';
import type { Result } from '@/shared/helpers/Result';

import { MeasurementsDialogContent } from './measurements-dialog-content';

type Props = {
  sku?: Partial<SkuDTO>;
  measurement?: Partial<MeasurementDTO> | null;
  title: string;
  isLoading?: boolean;
  onSubmit?: (data: Partial<SkuDTO>) => Promise<Result> | Promise<void> | void;
};

function getMeasurementValue(value?: number, unit?: string) {
  if (value === undefined || value === null || !unit) return undefined;
  return formatMeasurement(value, unit);
}

export function MeasurementsSection({
  sku,
  measurement = sku?.measurement,
  title,
  isLoading,
  onSubmit,
}: Props) {
  const list = (
    <DetailList
      title={title}
      isLoading={isLoading}
      action={
        onSubmit ? (
          <DialogTrigger asChild>
            <DetailEditButton disabled={isLoading} />
          </DialogTrigger>
        ) : undefined
      }
      items={[
        {
          icon: MoveHorizontalIcon,
          label: 'Length',
          value: getMeasurementValue(measurement?.length, measurement?.dimensionUnit),
        },
        {
          icon: MoveDiagonal2Icon,
          label: 'Width',
          value: getMeasurementValue(measurement?.width, measurement?.dimensionUnit),
        },
        {
          icon: MoveVerticalIcon,
          label: 'Height',
          value: getMeasurementValue(measurement?.height, measurement?.dimensionUnit),
        },
        {
          icon: ScaleIcon,
          label: 'Weight',
          value: getMeasurementValue(measurement?.weight, measurement?.weightUnit),
        },
      ]}
    />
  );

  if (!onSubmit) {
    return list;
  }

  return (
    <FormDialog>
      {list}
      <MeasurementsDialogContent sku={sku} onSubmit={onSubmit} />
    </FormDialog>
  );
}
